import { mergeDeepAssign } from '@utils/objects'
import { toActionName } from '@store/utils'

const modules = Object
  .fromEntries(require
    .context('./', true, /^\.\/\w+$/)
    .keys()
    .map(path => path.slice(2))
    .filter(path => path !== 'index')
    .map(moduleName => [moduleName, require(`./${moduleName}`).default]))

export default Object.entries(modules).map(([moduleKey, storeModule]) => {
  if (!storeModule.auto) storeModule.auto = []

  const auto = new Set(storeModule.auto === '*'
    ? ['actions', 'getters', 'mutations', 'sync']
    : storeModule.auto)

  return Object.assign(
    mergeDeepAssign({
      // external service name without apiBase (someService)
      serviceName: auto.has('actions')
        ? moduleKey
        : null,

      isClearable: auto.has('mutations') && storeModule.isClearable !== false,
      isFrozen: false,

      cacheFor: 7000,

      // suffix for store actions (SOME_SERVICE)
      tableName: moduleKey,
      storeSuffix: toActionName(moduleKey),
      // internal store key (someService) used for queries
      storeKey: moduleKey,

      store: {
        state: {
          list: {},
          pages: {},
        },
      },
    }, storeModule),
    { auto })
})
